// Section to show the billing cycles and invoice lines for each to explain what the payment was for

import { InvoicePaymentCard } from '@views/Invoice/InvoicePaymentCard';
import { BillingCycle } from '@views/Invoice/invoiceTypes';

// Should be a list/table of all invoice lines grouped by billing cycle, split into line cost + vat
export function PaymentDetails({
  billingCycles,
}: {
  billingCycles: BillingCycle[];
}) {
  return (
    <div className='space-y-4'>
      <h3 className='text-lg font-semibold text-gray-900'>
        This payment covers
        {billingCycles.length > 1 ? ' these invoices:' : ' this invoice:'}
      </h3>
      {billingCycles.map(
        (billingCycle) =>
          billingCycle.floxToShipperInvoice && (
            <InvoicePaymentCard
              isPaid
              key={billingCycle.id}
              billingCycle={billingCycle}
              invoice={billingCycle.floxToShipperInvoice}
              onToggleSelected={() => {}}
            />
          )
      )}
    </div>
  );
}
